/// <reference path="../../_ext/Editors/ItemEditorDialog.ts" />

namespace TabAurous.Finance {

    @Serenity.Decorators.registerClass()
    export class ServiceOutwardDetailsDialog extends _Ext.EditorDialogBase<ServiceOutwardDetailsRow> {
        protected getFormKey() { return ServiceOutwardDetailsForm.formKey; }
        protected getLocalTextPrefix() { return ServiceOutwardDetailsRow.localTextPrefix; }
        protected getDeletePermission() { return ServiceOutwardDetailsRow.deletePermission; }
        protected getInsertPermission() { return ServiceOutwardDetailsRow.insertPermission; }
        protected getUpdatePermission() { return ServiceOutwardDetailsRow.updatePermission; }
        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        }
        protected form = new ServiceOutwardDetailsForm(this.idPrefix);
        
    }
}